export type AssetSymbolTarget = {
  resourceSetId: string;
  /** Ids and names that identify this asset's graphic on the map. */
  matchIds: string[];
  layerId?: string;
  objectId?: number;
};

/** True when the graphic stays drawn, false when its asset is hidden, null when it is not an asset symbol. */
export function symbolVisibleForGraphic(
  graphicKeys: string[],
  targets: AssetSymbolTarget[],
  hiddenResourceSetIds: ReadonlySet<string>
): boolean | null {
  const owners = new Set<string>();
  const keys = new Set(graphicKeys.filter(Boolean));
  if (keys.size === 0) return null;
  for (const target of targets) {
    if (target.matchIds.some((id) => keys.has(id))) {
      owners.add(target.resourceSetId);
    }
  }
  if (owners.size === 0) return null;
  for (const owner of owners) {
    if (hiddenResourceSetIds.has(owner)) return false;
  }
  return true;
}
